var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServMob5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 182,
    viewBox: "0 0 343 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_161)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 182,
    rx: 8,
    fill: "#61C4B7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 24,
    width: 64,
    height: 64,
    fill: "#EB7565"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 40,
    r: 14,
    stroke: "#030303",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 56,
    r: 14,
    stroke: "#FFF7F0",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 80,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 80,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 80,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 24,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 24,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 24,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 28,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 28,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 28,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 52,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 52,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 52,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255 56L287 88V56H255Z",
    fill: "#FFF7F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255 56L287 88V56H255Z",
    fill: "#552049"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191 88L159 56V88H191Z",
    fill: "#F39E9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255 56L287 24V56H255Z",
    fill: "#FFF7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.728 153H28.992V146.4H32.4C33.616 146.4 34.688 146.184 35.616 145.752C36.544 145.304 37.272 144.656 37.8 143.808C38.344 142.96 38.616 141.944 38.616 140.76C38.616 139.544 38.352 138.52 37.824 137.688C37.296 136.856 36.56 136.224 35.616 135.792C34.688 135.344 33.616 135.12 32.4 135.12H25.728V153ZM28.992 143.52V138H32.448C33.328 138 34.032 138.248 34.56 138.744C35.088 139.24 35.352 139.912 35.352 140.76C35.352 141.592 35.088 142.264 34.56 142.776C34.032 143.272 33.328 143.52 32.448 143.52H28.992ZM41.0265 153H44.1705V145.344C44.1705 144.496 44.4185 143.816 44.9145 143.304C45.4105 142.792 46.0425 142.536 46.8105 142.536C47.5785 142.536 48.2105 142.792 48.7065 143.304C49.2025 143.8 49.4505 144.48 49.4505 145.344V153H52.5945V144.6C52.5945 143.624 52.3865 142.768 51.9705 142.032C51.5545 141.28 50.9705 140.696 50.2185 140.28C49.4825 139.864 48.6345 139.656 47.6745 139.656C46.9225 139.656 46.2425 139.792 45.6345 140.064C45.0265 140.32 44.5385 140.712 44.1705 141.24V134.832H41.0265V153ZM61.6371 153.288C62.9011 153.288 64.0531 153 65.0931 152.424C66.1331 151.832 66.9651 151.024 67.5891 150C68.2131 148.96 68.5251 147.784 68.5251 146.472C68.5251 145.16 68.2131 143.992 67.5891 142.968C66.9811 141.944 66.1571 141.136 65.1171 140.544C64.0771 139.952 62.9171 139.656 61.6371 139.656C60.3411 139.656 59.1731 139.952 58.1331 140.544C57.0931 141.136 56.2611 141.944 55.6371 142.968C55.0291 143.992 54.7251 145.16 54.7251 146.472C54.7251 147.784 55.0291 148.952 55.6371 149.976C56.2611 151 57.0931 151.808 58.1331 152.4C59.1891 152.992 60.3571 153.288 61.6371 153.288ZM61.6371 150.408C60.9331 150.408 60.3011 150.24 59.7411 149.904C59.1971 149.568 58.7651 149.104 58.4451 148.512C58.1411 147.904 57.9891 147.224 57.9891 146.472C57.9891 145.72 58.1411 145.048 58.4451 144.456C58.7651 143.864 59.1971 143.4 59.7411 143.064C60.3011 142.712 60.9331 142.536 61.6371 142.536C62.3411 142.536 62.9571 142.712 63.4851 143.064C64.0291 143.4 64.4531 143.864 64.7571 144.456C65.0771 145.048 65.2371 145.72 65.2371 146.472C65.2371 147.224 65.0771 147.904 64.7571 148.512C64.4531 149.104 64.0291 149.568 63.4851 149.904C62.9571 150.24 62.3411 150.408 61.6371 150.408ZM76.6269 153.144C77.1549 153.144 77.6749 153.104 78.1869 153.024V150.312C77.8829 150.36 77.6029 150.384 77.3469 150.384C76.5789 150.384 76.0189 150.208 75.6669 149.856C75.3149 149.504 75.1389 149 75.1389 148.344V142.752H78.1389V139.944H75.1389V136.968H71.9949V137.976C71.9949 138.616 71.8189 139.104 71.4669 139.44C71.1149 139.776 70.6189 139.944 69.9789 139.944H69.7389V142.752H71.9949V148.512C71.9949 149.968 72.3949 151.104 73.1949 151.92C74.0109 152.736 75.1549 153.144 76.6269 153.144ZM86.8558 153.288C88.1198 153.288 89.2718 153 90.3118 152.424C91.3518 151.832 92.1838 151.024 92.8078 150C93.4318 148.96 93.7438 147.784 93.7438 146.472C93.7438 145.16 93.4318 143.992 92.8078 142.968C92.1998 141.944 91.3758 141.136 90.3358 140.544C89.2958 139.952 88.1358 139.656 86.8558 139.656C85.5598 139.656 84.3918 139.952 83.3518 140.544C82.3118 141.136 81.4798 141.944 80.8558 142.968C80.2478 143.992 79.9438 145.16 79.9438 146.472C79.9438 147.784 80.2478 148.952 80.8558 149.976C81.4798 151 82.3118 151.808 83.3518 152.4C84.4078 152.992 85.5758 153.288 86.8558 153.288ZM86.8558 150.408C86.1518 150.408 85.5198 150.24 84.9598 149.904C84.4158 149.568 83.9838 149.104 83.6638 148.512C83.3598 147.904 83.2078 147.224 83.2078 146.472C83.2078 145.72 83.3598 145.048 83.6638 144.456C83.9838 143.864 84.4158 143.4 84.9598 143.064C85.5198 142.712 86.1518 142.536 86.8558 142.536C87.5598 142.536 88.1758 142.712 88.7038 143.064C89.2478 143.4 89.6718 143.864 89.9758 144.456C90.2958 145.048 90.4558 145.72 90.4558 146.472C90.4558 147.224 90.2958 147.904 89.9758 148.512C89.6718 149.104 89.2478 149.568 88.7038 149.904C88.1758 150.24 87.5598 150.408 86.8558 150.408ZM102.464 158.28C103.712 158.28 104.816 158.024 105.776 157.512C106.736 157 107.488 156.296 108.032 155.4C108.576 154.504 108.848 153.488 108.848 152.352V139.944H105.872V141.456C104.88 140.256 103.544 139.656 101.864 139.656C100.664 139.656 99.5921 139.936 98.6481 140.496C97.7041 141.04 96.9601 141.792 96.4161 142.752C95.8721 143.712 95.6001 144.808 95.6001 146.04C95.6001 147.256 95.8721 148.352 96.4161 149.328C96.9601 150.304 97.7121 151.072 98.6721 151.632C99.6321 152.192 100.72 152.472 101.936 152.472C103.52 152.472 104.776 151.96 105.704 150.936V152.352C105.704 153.312 105.4 154.056 104.792 154.584C104.184 155.128 103.408 155.4 102.464 155.4C101.632 155.4 100.928 155.208 100.352 154.824C99.7921 154.456 99.4161 153.968 99.2241 153.36L96.2961 154.464C96.7121 155.616 97.4721 156.536 98.5761 157.224C99.6961 157.928 100.992 158.28 102.464 158.28ZM102.32 149.568C101.312 149.568 100.48 149.24 99.8241 148.584C99.1841 147.912 98.8641 147.072 98.8641 146.064C98.8641 145.392 99.0081 144.792 99.2961 144.264C99.6001 143.72 100.016 143.296 100.544 142.992C101.072 142.688 101.664 142.536 102.32 142.536C103.312 142.536 104.12 142.872 104.744 143.544C105.384 144.2 105.704 145.04 105.704 146.064C105.704 147.088 105.384 147.928 104.744 148.584C104.12 149.24 103.312 149.568 102.32 149.568ZM111.784 153H114.928V145.728C114.928 144.736 115.2 143.968 115.744 143.424C116.304 142.864 117.024 142.584 117.904 142.584H119.032V139.8H118.264C117.464 139.8 116.76 139.944 116.152 140.232C115.544 140.52 115.072 141.04 114.736 141.792V139.944H111.784V153ZM124.721 153.288C126.417 153.288 127.777 152.728 128.801 151.608V153H131.777V144.312C131.777 143.4 131.545 142.592 131.081 141.888C130.617 141.184 129.977 140.64 129.161 140.256C128.361 139.856 127.425 139.656 126.353 139.656C125.041 139.656 123.873 139.968 122.849 140.592C121.825 141.216 121.121 142.04 120.737 143.064L123.305 144.312C123.545 143.72 123.921 143.248 124.433 142.896C124.945 142.528 125.545 142.344 126.233 142.344C126.953 142.344 127.529 142.536 127.961 142.92C128.409 143.288 128.633 143.752 128.633 144.312V144.744L124.745 145.368C123.209 145.624 122.073 146.112 121.337 146.832C120.601 147.552 120.233 148.456 120.233 149.544C120.233 150.696 120.641 151.608 121.457 152.28C122.273 152.952 123.361 153.288 124.721 153.288ZM123.497 149.424C123.497 148.512 124.113 147.936 125.345 147.696L128.633 147.144V147.672C128.633 148.568 128.321 149.328 127.697 149.952C127.089 150.576 126.289 150.888 125.297 150.888C124.769 150.888 124.337 150.76 124.001 150.504C123.665 150.232 123.497 149.872 123.497 149.424ZM134.683 157.8H137.827V151.752C138.307 152.248 138.891 152.632 139.579 152.904C140.267 153.16 141.011 153.288 141.811 153.288C143.075 153.288 144.203 152.992 145.195 152.4C146.187 151.792 146.971 150.976 147.547 149.952C148.123 148.912 148.411 147.752 148.411 146.472C148.411 145.192 148.123 144.04 147.547 143.016C146.971 141.976 146.187 141.16 145.195 140.568C144.203 139.96 143.083 139.656 141.835 139.656C140.939 139.656 140.131 139.816 139.411 140.136C138.691 140.456 138.099 140.904 137.635 141.48V139.944H134.683V157.8ZM141.451 150.408C140.763 150.408 140.139 150.24 139.579 149.904C139.035 149.568 138.603 149.104 138.283 148.512C137.979 147.92 137.827 147.24 137.827 146.472C137.827 145.704 137.979 145.024 138.283 144.432C138.603 143.84 139.035 143.376 139.579 143.04C140.139 142.704 140.763 142.536 141.451 142.536C142.171 142.536 142.803 142.712 143.347 143.064C143.907 143.4 144.347 143.864 144.667 144.456C144.987 145.048 145.147 145.72 145.147 146.472C145.147 147.224 144.987 147.904 144.667 148.512C144.347 149.104 143.907 149.568 143.347 149.904C142.803 150.24 142.171 150.408 141.451 150.408ZM150.808 153H153.952V145.344C153.952 144.496 154.2 143.816 154.696 143.304C155.192 142.792 155.824 142.536 156.592 142.536C157.36 142.536 157.992 142.792 158.488 143.304C158.984 143.8 159.232 144.48 159.232 145.344V153H162.376V144.6C162.376 143.624 162.168 142.768 161.752 142.032C161.336 141.28 160.752 140.696 160 140.28C159.264 139.864 158.416 139.656 157.456 139.656C156.704 139.656 156.024 139.792 155.416 140.064C154.808 140.32 154.32 140.712 153.952 141.24V134.832H150.808V153ZM166.384 158.304C167.616 158.304 168.64 157.952 169.456 157.248C170.288 156.56 170.952 155.584 171.448 154.32L177.136 139.944H173.728L170.368 148.944L166.984 139.944H163.6L168.76 153L168.472 153.696C168.216 154.24 167.92 154.68 167.584 155.016C167.264 155.352 166.744 155.52 166.024 155.52C165.768 155.52 165.496 155.496 165.208 155.448C164.92 155.416 164.664 155.368 164.44 155.304V157.944C164.712 158.072 165.016 158.16 165.352 158.208C165.688 158.272 166.032 158.304 166.384 158.304Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 182,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServMob5);
export default __webpack_public_path__ + "static/media/serv_mob5.affe017859c02e3532069b57ba8ebba0.svg";
export { ForwardRef as ReactComponent };